import Vars from '../../vars';

import Validation from '../classes/Validation';

import Modal from '../../components/Modal';
import Request from '../../components/request';
import Utils from '../../components/utils';

import DropzoneSection from '../dropzone/section';

import Flat from './Flat';
import Floor from './Floor';
import Action from "../classes/Action";
import $ from "jquery";

class Section {
    constructor(args) {
        let self = this;

        self._setArgs(args);
        self._init();
    }

    _elems = {
        $_       : $(),
        $content : $('.content'),
        $create  : $(),
        $edit    : $(),
        $sort    : $(),
        $clone   : $(),
        $modal   : $(),
        $form    : $(),
        control  : {
            $add    : $(),
            $create : $(),
            $edit   : $(),
            $remove : $()
        }
    };

    _const = {
        entities : 'sections',
        entity   : 'section',
        title : {
            add  : 'Добавление новой секции',
            edit : 'Редактирование секции'
        },
        parent   : {
            entities : 'buildings',
            entity   : 'building',
            parent   : {
                entities : 'objects',
                entity   : 'object',
            }
        }
    };

    _state = {
        dropzone : {}
    };

    _args = {
        mode     : '',
        chess    : {},
        item     : {},
        index    : {},
        building : {},
        object   : {},
        progress : {},
        controlSection : {}
    };

    _actions = {

    };

    _utils = {
        validation : {}
    };

    _setArgs = (args) => {
        let self = this;

        self._args.chess    = args.chess;
        self._args.item     = args.item;
        self._args.index    = args.index;
        self._args.building = args.building || self._args.building;
        self._args.object   = Object.keys(self._args.building).length && self._args.building.object ? self._args.building.object : self._args.object;

        self._args.progress = args.progress || self._args.progress;
        self._args.controlSection = args.controlSection && Object.keys(args.controlSection).length ? args.controlSection : {}

        self._elems.$_   = args.root;

        self._args.mode = args.mode;
    };

    _setValidation = () => {
        let self = this;

        if (!self._elems.$form.length) return;

        self._utils.validation = new Validation({
            form : self._elems.$form
        });
    };

    _setDropzone = () => {
        let self = this;

        self._state.dropzone.items = DropzoneSection.get({
            item     : self._args.item,
            parent1  : self._args.object,
            parent2  : self._args.building,
            entities : self._const.entities
        });
        self._state.dropzone.entity = self._args.item;
    };

    _building = () => {
        let self = this;

        if (Object.keys(self._args.item).length) {
            self._args.chess._initializeSection(self._args.item, self._args.index, self._elems.$_);
        }

        self._bindElements();
        self._bindUI();
    };

    _control = () => {
        let self = this;

        self._bindElements();
        self._bindUI();
    };

    _initModal = () => {
        let self = this;

        self._setDropzone();

        self._elems.$modal = new Modal({
            title   : Object.keys(self._args.item).length ? self._const.title.edit : self._const.title.add,
            content : Utils.renderProfileTemplate(self._const.entity + '-form', {
                section  : Object.keys(self._args.item).length ? self._args.item : null,
                building : Object.keys(self._args.building).length ? self._args.building : null
            }),
            dropzone            : self._state.dropzone,
            closingConfirmation : true,
            confirm             : function(args) {
                self._bindSubmit(args);
            }
        });

        if (!self._elems.$modal.length) return;

        self._elems.$form = self._elems.$modal.find('form');
        if (!self._elems.$form.length) return;

        self._updatePreview();
        self._updateForm();
        self._bindForm();

        if (Object.keys(self._args.item).length && (self._args.item.has_ground_floor || self._args.item.count_of_underground_floors > 0)) {
            self._args.item.floors.filter(function(floor) {
                return floor.number <= 0;
            }).sort(function(floor0, floor1) {
                return floor1.number - floor0.number;
            }).forEach(function(floor) {
                $('#section-form-ground-floor-options .table').append(Utils.renderProfileTemplate('section-form-ground-floor-options', {
                    floor: floor
                }));
            });
        }
    };

    _updatePreview = () => {
        let self = this;

        if (!self._elems.$form.length) return;

        let $preview = self._elems.$form.find('.form-text-preview');
        if (!$preview.length) return;

        const name        = self._elems.$form.find('input[name="section[name]"]').val();
        const number      = self._elems.$form.find('input[name="section[number]"]').val();

        if (name) {
            $preview.text(ifacade.constants.sections.types[self._args.building.section_type].name + ' ' + name).slideDown();
        } else if(number) {
            $preview.text(ifacade.constants.sections.types[self._args.building.section_type].name + ' ' + number).slideDown();
        } else {
            $preview.text(ifacade.constants.sections.types[self._args.building.section_type].name + '...').slideUp();
        }
    };

    _updateForm = () => {
        let self = this;

        if (!self._elems.$form.length) return;

        const checks = {
            bearing_structure_material: 	self._elems.$form.find('select[name="section[bearing_structure_material]"]').val(),
            outside_wall_material: 			self._elems.$form.find('select[name="section[outside_wall_material]"]').val(),
            started_at_year: 				self._elems.$form.find('select[name="section[started_at_year]"]').val(),
            started_at_month_or_quarter: 	self._elems.$form.find('select[name="section[started_at_month_or_quarter]"]').val(),
            deadline_year: 					self._elems.$form.find('select[name="section[deadline_year]"]').val(),
            deadline_month_or_quarter: 		self._elems.$form.find('select[name="section[deadline_month_or_quarter]"]').val(),
            hand_over: 						self._elems.$form.find('.form-field[data-name="hand_over"] .checkbox').hasClass('checked')
        };

        if (checks.started_at_year) {
            self._elems.$form.find('select[name="section[started_at_month_or_quarter]"]').prop('disabled', false);
        } else {
            self._elems.$form.find('select[name="section[started_at_month_or_quarter]"]').prop('disabled', true).val('');
            self._elems.$form.find('select[name="section[started_at_day]"]').prop('disabled', true).val('');
        }

        if (checks.started_at_month_or_quarter && parseInt(checks.started_at_month_or_quarter) < 100) {
            self._elems.$form.find('select[name="section[started_at_day]"]').prop('disabled', false);
        } else {
            self._elems.$form.find('select[name="section[started_at_day]"]').prop('disabled', true).val('');
        }

        if (checks.deadline_year) {
            self._elems.$form.find('select[name="section[deadline_month_or_quarter]"]').prop('disabled', false);
        }
        else {
            self._elems.$form.find('select[name="section[deadline_month_or_quarter]"]').prop('disabled', true).val('');
            self._elems.$form.find('select[name="section[deadline_day]"]').prop('disabled', true).val('');
        }

        if (checks.deadline_month_or_quarter && parseInt(checks.deadline_month_or_quarter) < 100) {
            self._elems.$form.find('select[name="section[deadline_day]"]').prop('disabled', false);
        }
        else {
            self._elems.$form.find('select[name="section[deadline_day]"]').prop('disabled', true).val('');
        }

        if (checks.hand_over) {
            self._elems.$form.find('#section-form-planned-deadline-title').hide();
            self._elems.$form.find('#section-form-real-deadline-title').show();
        }
        else {
            self._elems.$form.find('#section-form-planned-deadline-title').show();
            self._elems.$form.find('#section-form-real-deadline-title').hide();
        }

        if (checks.bearing_structure_material == 'extra') {
            self._elems.$form.find('.form-field[data-name="bearing_structure_material"] .input').show();
        }
        else {
            self._elems.$form.find('.form-field[data-name="bearing_structure_material"] .input').hide();
        }

        if (checks.outside_wall_material == 'extra') {
            self._elems.$form.find('.form-field[data-name="outside_wall_material"] .input').show();
        }
        else {
            self._elems.$form.find('.form-field[data-name="outside_wall_material"] .input').hide();
        }
    };

    _bindElements = () => {
        let self = this;

        if (!self._elems.$_.length) return;

        self._elems.$create = self._elems.$content.find('.chess__container .js-profile-section-create');
        self._elems.$edit   = self._elems.$_.find('.js-profile-section-edit');
        self._elems.$sort   = self._elems.$_.find('.js-profile-section-sort');
        self._elems.$clone  = self._elems.$_.find('.js-profile-section-clone');

        self._elems.control.$create = self._elems.$_.find('.js-profile-section-create');

        if (self._args.mode == Vars.view.control) {
            self._elems.control.$add = self._elems.$_.find('.js-profile-control-add');
            self._elems.control.$edit = self._elems.$_.find('.js-profile-control-edit');
            self._elems.control.$remove = self._elems.$_.find('.js-profile-control-delete');
        }
    };

    _bindActions = () => {
        let self = this;

        /*new Action({
            id       : self._args.item.id,
            actions  : self._actions,
            entities : self._const.entities,
            entity   : self._const.entity,
            prefix   : 'objects/' + self._args.item.object_id + '/buildings/' + self._args.item.building_id,
            self     : self
        });*/
    };

    _bindForm = () => {
        let self = this;
        
        if (!self._elems.$form.length) return;

        self._setValidation();

        self._elems.$form.find('input[name="section[name]"]').keyup(function() {
            self._updatePreview();
        });

        self._elems.$form.find('select[name="section[bearing_structure_material]"]').change(function(){
            self._updateForm();
        });
        self._elems.$form.find('select[name="section[outside_wall_material]"]').change(function(){
            self._updateForm();
        });
        self._elems.$form.find('select[name="section[started_at_year]"]').change(function(){
            self._updateForm();
        });
        self._elems.$form.find('select[name="section[started_at_month_or_quarter]"]').change(function(){
            self._updateForm();
        });
        self._elems.$form.find('select[name="section[deadline_year]"]').change(function(){
            self._updateForm();
        });
        self._elems.$form.find('select[name="section[deadline_month_or_quarter]"]').change(function(){
            self._updateForm();
        });
        self._elems.$form.find('.form-field[data-name="hand_over"] .checkbox').on('change', function(){
            self._updateForm();
        });

        self._elems.$form.find('.form-field[data-name="has_ground_floor"] .checkbox').on('check', function() {
            $('#section-form-ground-floor-options').show();
            $('#section-form-ground-floor-options .table').prepend(Utils.renderProfileTemplate('section-form-ground-floor-options', {
                floor: {
                    number: 0,
                    has_no_flats: false
                }
            }));
        }).on('uncheck', function() {
            let count_of_underground_floors = parseInt(self._elems.$form.find('input[name="section[count_of_underground_floors]"]').val());

            if (isNaN(count_of_underground_floors) || count_of_underground_floors < 1 || count_of_underground_floors > 20) {
                $('#section-form-ground-floor-options').hide();
                $('#section-form-ground-floor-options .table').html('');
                return;
            }

            $('#section-form-ground-floor-options').show();
            $('#section-form-ground-floor-options .table').children().eq(0).remove();
        });

        self._elems.$form.find('input[name="section[count_of_underground_floors]"]').on('keyup', function() {
            let count_of_underground_floors = parseInt($(this).val());
            count_of_underground_floors = isNaN(count_of_underground_floors) ? 0 : count_of_underground_floors;
            let has_ground_floor = self._elems.$form.find('.form-field[data-name="has_ground_floor"] .checkbox').hasClass('checked');
            if (!has_ground_floor && (count_of_underground_floors < 1 || count_of_underground_floors > 20)) {
                $('#section-form-ground-floor-options').hide();
                $('#section-form-ground-floor-options .table').html('');
                return;
            }
            let old_count_of_underground_floors = $('#section-form-ground-floor-options .table').children().length - has_ground_floor;

            if (old_count_of_underground_floors < count_of_underground_floors) {
                for (let floor_number = -old_count_of_underground_floors - 1; floor_number >= -count_of_underground_floors; --floor_number) {
                    $('#section-form-ground-floor-options .table').append(Utils.renderProfileTemplate('section-form-ground-floor-options', {
                        floor: {
                            number: floor_number,
                            has_no_flats: false
                        }
                    }));
                }
            }
            else if (old_count_of_underground_floors > count_of_underground_floors) {
                $('#section-form-ground-floor-options .table').children().slice(has_ground_floor + count_of_underground_floors).remove();
            }
            $('#section-form-ground-floor-options').show();
        });

        self._elems.$form.find('input[name="section[video_link]"]').change(function() {
            $(this).parents('.form-field').removeClass('error');
            $(this).parent().next('.form-field__message').empty();
        });
        self._elems.$form.find('input[name="section[video_link]"]').keyup(function() {
            $(this).parents('.form-field').removeClass('error');
            $(this).parent().next('.form-field__message').empty();
        });
    };

    _bindSubmit = (args) => {
        let self = this;

        let $modal = args.modal;
        if (!$modal.length) return;
        let $form = $modal.find('form');
        if (!$form.length) return;

        const errors = $form.find('.form-field.error').length;

        if(errors) return;

        loader.increase();

        Request.send({
            path   : '/api/objects/' + self._args.object.id + '/buildings/' + self._args.building.id + '/' + self._const.entities + '/' + (Object.keys(self._args.item).length ? self._args.item.id + '/edit' : 'create'),
            method : 'POST',
            data   : $form.serialize(),
            done: function(response) {
                loader.decrease();
                if (response.error) {
                    self._utils.validation.showErrors(response.error);
                    return;
                }

                $modal.trigger('close');

                let section = response[self._const.entity];
                for (let i in self._args.building.sections) {
                    if (self._args.building.sections[i].id == section.id) {
                        self._args.building.sections[i] = section;
                    }
                    if (self._args.item.id == section.id) {
                        self._args.item = section;
                    }
                }

                if (Object.keys(self._args.controlSection).length) {
                    for (let i in self._args.controlSection._args.building.sections) {
                        if (self._args.controlSection._args.building.sections[i].id == section.id) {
                            self._args.controlSection._args.building.sections[i] = section;
                        }
                        if (Object.keys(self._args.controlSection._args.item).length && self._args.controlSection._args.item.id == section.id) {
                            self._args.item = section;
                        }
                    }
                }

                let sections = self._args.building.sections.filter(function(s){
                    return s.id == section.id;
                });
                let key = sections.length ? ifacade_findWithAttr(self._args.building.sections, 'id', section.id) : self._args.building.sections.length;
                self._args.building.sections[key] = response[self._const.entity];

                self._args.building.facades.forEach(function(facade) {
                    facade.polygons = facade.polygons.filter(function(polygon) {
                        if (polygon.section_id != response[self._const.entity].id)
                            return true;
                        if (polygon.floor_id === undefined)
                            return true;
                        return response.section.floors.some(function(floor) {
                            return floor.id == polygon.floor_id;
                        });
                    });
                });

                self._args.chess._args.building = self._args.building;
                if(!Object.keys(self._args.item).length) {
                    $('.chess__no-sections').remove();
                    $('<div />').addClass('chess__section').appendTo($('.chess__slider'));
                }
                self._args.chess._unselectAll();
                self._args.chess._updateSections();
                self._args.chess._updateStickySections();

                self._args.chess._args.buildingSelf._state.item.sections = self._args.building.sections;
                self._args.chess._args.buildingSelf._bindUI();

                self._args.progress.update({
                    object : self._args.object
                });

                if(!Object.keys(self._args.item).length) return;
                self._args.chess._updateFlatTitles();
            }
        });
    };

    _bindUI = () => {
        let self = this;

        self._elems.$create.length && self._elems.$create.unbind('click').on('click', function(e) {
            e.preventDefault();
            loader.increase();
            Request.send({
                path: '/api/objects/' + self._args.object.id + '/buildings/' + self._args.building.id,
                data: {
                    info: 'for_section'
                },
                done: function(response) {
                    loader.decrease();
                    Utils.scrollToTop();

                    self._args.building  = response.building;
                    self._args.item      = {};

                    self._initModal();
                }
            });
        });

        self._elems.$edit.length && self._elems.$edit.unbind('click').on('click', function(e) {
            e.preventDefault();

            loader.increase();
            Request.send({
                path: '/api/objects/' + self._args.object.id + '/buildings/' + self._args.building.id,
                data: {
                    info: 'for_section'
                },
                done : function(response) {
                    loader.decrease();
                    Utils.scrollToTop();

                    self._args.building = response.building;
                    self._args.item     = self._args.building.sections.filter(function(section){
                        return section.id === self._args.item.id;
                    }).pop();

                    self._initModal();
                }
            });
        });

        self._elems.$sort.length && self._elems.$sort.unbind('click').on('click', function(e) {
            e.preventDefault();
            loader.increase();

            const action = $(this).data('action');

            Request.send({
                path: '/api/objects/' + self._args.object.id + '/buildings/' + self._args.building.id + '/sections/' + self._args.item.id + '/sort/' + action,
                data: {
                    info: 'for_section'
                },
                done: function(response) {
                    loader.decrease();
                    Utils.scrollToTop();

                    response.building.sections.forEach(function(section){
                        let id = section.id;

                        for(let i = 0; i < Object.keys(self._args.building.sections).length; i++ ) {
                            let s = self._args.building.sections[i];
                            if (s.id == id) {
                                self._args.building.sections[i].number = section.number;
                            }
                        }

                    });

                    window.chess._args.building.sections = self._args.building.sections;
                    window.chess._unselectAll();
                    window.chess._updateSections();
                    window.chess._updateStickySections();

                    window.chess._args.buildingSelf._state.item.sections = self._args.building.sections;
                    window.chess._args.buildingSelf._bindUI();

                    self._args.progress.update({
                        object : self._args.object
                    });
                }
            });
        });

        self._elems.$clone.length && self._elems.$clone.unbind('click').on('click', function(e) {
            e.preventDefault();

            loader.increase();

            Request.send({
                path: '/api/objects',
                data: { with : 'buildings' },

                done: function(response) {
                    loader.decrease();

                    if (response.error) return;

                    let objects = [];
                    response.objects.forEach(function(object){
                        objects
                    });

                    let $modal = new Modal({
                        title   : 'Копирование секции',
                        content : Utils.renderProfileTemplate('form', {
                            entity   : 'clonning_section',
                            fields   : {
                                object_id : {
                                    title       : 'Объект',
                                    description : 'Выберите объект, в который будет скопирована данная секция',
                                    type        : 'select',
                                    required    : true,
                                    id          : 'id',
                                    value       : self._args.item.object_id,
                                    options     : response.objects,
                                    name        : function(object) {
                                        return ifacade.constants.objects.types[object.type].short_name + ' "' + object.name + '"';
                                    }
                                },
                                building_id : {
                                    title       : 'Дом',
                                    description : 'Выберите дом, в который будет скопирована данная секция',
                                    type        : 'select',
                                    required    : true,
                                    id          : 'id',
                                    value       : self._args.item.building_id,
                                    options     : response.objects.filter(function(object) {
                                        return object.id == self._args.object.id;
                                    })[0].buildings,
                                    name        : function(building) {
                                        return 'Дом ' + (building.name != '' ? building.name : '№' + building.number);
                                    }
                                }
                            },
                            buttons  : {
                                one : {
                                    class : 'confirm button--edit',
                                    title : 'Скопировать секцию',
                                    type  : 'submit'
                                },
                                two : null
                            }
                        }),
                        confirm : function(args) {
                            let $modal = args.modal;
                            let $form = $modal.find('form');
                            if (!$form.length) return;

                            const objectId = parseInt($form.find('select[name="clonning_section[object_id]"]').val());
                            const buildingId = parseInt($form.find('select[name="clonning_section[building_id]"]').val());

                            $modal.find('.form-field').each(function() {
                                $(this).removeClass('error').find('.form-field__message').addClass('hidden').text('');
                            });

                            if (!buildingId) {
                                let $building_field = $form.find('.form-field[data-name="clonning_section.building_id"]');
                                $building_field.addClass('error');

                                $building_field
                                    .find('.form-field__message').removeClass('hidden')
                                    .text('Необходимо указать дом, в который будет скопирована данная секция');

                                return;
                            }

                            loader.increase();

                            return Request.send({
                                path: '/api/objects/' + objectId + '/buildings/' + buildingId + '/copySectionFrom',
                                data: { section_id: self._args.item.id },

                                done: function(response) {
                                    loader.decrease();

                                    if (response.error) return;

                                    $modal.trigger('close');

                                    if (self._args.building.id == buildingId) {
                                        self._elems.$content.find('.chess__no-sections').remove();
                                        $('<div />').addClass('chess__section').appendTo(self._elems.$content.find('.chess__slider'));
                                        //window.chess._args.building.sections.push(response.cloned_section);
                                        self._args.building.sections.push(response.cloned_section);
                                        if (Object.keys(self._args.controlSection).length){
                                            //self._args.controlSection._args.building.sections.push(response.cloned_section);
                                        }
                                        window.chess._unselectAll();
                                        window.chess._updateSections();
                                        window.chess._updateStickySections();
                                        window.chess._args.buildingSelf._bindActions();
                                    }
                                    else {
                                        new Modal({
                                            title: 		'Копирование секции',
                                            content: 	Utils.renderProfileTemplate('info', {
                                                message   : 'Секция была успешно скопирована',
                                                buttons : {
                                                    one : {
                                                        class : 'confirm button--edit',
                                                        title : 'Перейти к дому, в который была скопирована данная секция'
                                                    },
                                                    two : {
                                                        class : 'button--cancel',
                                                        title : 'Отменить'
                                                    }
                                                }
                                            }),
                                            confirm : function(args) {
                                                let $modal = args.modal;
                                                $modal.trigger('close');
                                                window.location.href = '#objects/' + objectId + '/buildings/' + buildingId;
                                            }
                                        });
                                    }
                                },
                            });
                        }
                    });

                    let $form = $modal.find('form');
                    if (!$form.length) return;

                    $form.find('select[name="clonning_section[object_id]"]').change(function() {
                        const objectId = parseInt($(this).val());
                        let buildings = response.objects.filter(function(object) {
                            return object.id == objectId;
                        })[0].buildings;

                        let $buildingSelect = $form.find('select[name="clonning_section[building_id]"]').html('');
                        //$('<option />').appendTo($buildingSelect);
                        buildings.forEach(function(building) {
                            $('<option />').val(building.id).text('Дом ' + (building.name ? building.name : '№' + building.number)).appendTo($buildingSelect);
                        });
                    });
                }
            });
        });

        self._elems.control.$add.length && self._elems.control.$add.unbind('click').on('click', function (e) {
            e.preventDefault();
            if ($(this).hasClass('disabled')) return;
            $('.chess__control__extra').removeClass('active').filter('.is-add').addClass('active');
        });
        self._elems.control.$edit.length && self._elems.control.$edit.unbind('click').on('click', function (e) {
            e.preventDefault();
            if ($(this).hasClass('disabled')) return;
            $('.chess__control__extra').removeClass('active').filter('.is-edit').addClass('active');
        });
        self._elems.control.$remove.length && self._elems.control.$remove.unbind('click').on('click', function (e) {
            e.preventDefault();
            if ($(this).hasClass('disabled')) return;
            $('.chess__control__extra').removeClass('active').filter('.is-delete').addClass('active');
        });

        Object.keys(self._args.item).length && self._elems.$_.find('.chess-section__actions .hamburger').unbind('click').on('click', function(e) {
            e.preventDefault();

            if($(this).hasClass('active')) {
                $(this).parent().removeClass('open');
                $(this).removeClass('active');
            }
            else {
                $(this).parent().addClass('open');
                $(this).addClass('active');
            }
        });

        self._bindControlUI();
        self._bindActions();
    };

    _bindControlUI = () => {
        let self = this;

        if (self._args.mode != Vars.view.control) return;

        self._elems.control.$create.length && self._elems.control.$create.unbind('click').on('click', function(e) {
            e.preventDefault();
            loader.increase();
            Request.send({
                path: '/api/objects/' + self._args.object.id + '/buildings/' + self._args.building.id,
                data: {
                    info: 'for_section'
                },
                done: function(response) {
                    loader.decrease();
                    Utils.scrollToTop();

                    self._args.building  = response.building;
                    self._args.item      = {};

                    self._initModal();
                }
            });
        });

        self._elems.$_.find('.js-profile-add-flats, .js-profile-add-group-flats').unbind('click').on('click', function(e){
            e.preventDefault();

            if ($(this).hasClass('disabled')) return;

            $('.chess__control__extra').removeClass('active');

            if (!self._args.building.sections.length) {
                new Modal({
                    title: 'Информация',
                    content: Utils.renderProfileTemplate('info', {
                        message   : 'Пожалуйста, добавьте хотя бы одну секцию перед тем, как добавить помещения.',
                        buttons : {
                            one : {
                                class : 'confirm button--edit',
                                title : 'Закрыть'
                            },
                            two : null
                        }
                    })
                });
                return;
            }

            if ($(this).hasClass('group')) {
                let selected_flats = self._args.chess._getNonExistentSelectedFlats();

                if (!selected_flats.length || selected_flats[0].flats.length < 2) {
                    new Modal({
                        title: 'Информация',
                        content: Utils.renderProfileTemplate('info', {
                            message : 'Пожалуйста, выделите хотя бы две пустые ячейки. Чтобы выделить пустые ячейки, достаточно нажать на каждую один раз.',
                            buttons : {
                                one : {
                                    class : 'confirm button--edit',
                                    title : 'Закрыть'
                                },
                                two : null
                            }
                        })
                    });
                    return;
                }

                let item = self._args.chess._getSectionById(selected_flats[0].id);
                const section_index = self._args.building.sections.indexOf(item) != -1 ? self._args.building.sections.indexOf(item) : self._args.building.sections.indexOf(self._args.building.sections.filter(function(section){
                    return section.id == item.id;
                }).pop());
                let $section = self._args.chess._elems.$slider.children().find('.chess-section[data-id="' + item.id + '"]');

                new Modal({
                    title: 'Следующий шаг',
                    content: Utils.renderProfileTemplate('info', {
                        message : 'Пожалуйста, выберите главное помещение группы.',
                        buttons : {
                            one : {
                                class : 'confirm button--edit',
                                title : 'Продолжить'
                            },
                            two : {
                                class : 'button--cancel',
                                title : 'Отменить'
                            }
                        }
                    }),
                    closing : function(args) {
                        self._args.chess._unselectAll();
                    },
                    confirm : function(args) {
                        args.modal.trigger('close');
                        self._args.chess.enableMainFlatSelectionMode(item, section_index, $section, selected_flats[0].flats, function (main_flat) {
                            loader.increase();

                            Request.send({
                                path: '/api/objects/' + self._args.object.id + '/buildings/' + self._args.building.id,
                                data: {
                                    info: 'for_flat'
                                },
                                done: function(response) {
                                    loader.decrease();
                                    Utils.scrollToTop();

                                    let sections         = self._args.building.sections.filter(function(section){
                                        return section.id == item.id;
                                    });
                                    if (!sections.length) return;
                                    self._args.item      = sections[0];
                                    self._args.building  = response.building;
                                    self._args.object    = self._args.building.object;

                                    new Flat({
                                        progress       : self._args.progress,
                                        section        : self._args.item,
                                        building       : self._args.building,
                                        group          : true,
                                        items          : selected_flats,
                                        item           : {},
                                        main_item      : main_flat,
                                        done           : function (response) {
                                            response.flats.forEach(function (response_flat) {
                                                self._args.item.flats.push(response_flat);
                                            });

                                            response.floors.forEach(function (response_floor) {
                                                let floor = null;
                                                var floor_index = -1;

                                                self._args.item.floors.some(function (current_floor, current_floor_index) {
                                                    if (current_floor.id != response_floor.id)
                                                        return false;
                                                    floor = current_floor;
                                                    floor_index = current_floor_index;
                                                    return true;
                                                });

                                                if (!floor) return;

                                                self._args.item.floors[floor_index] = response_floor;
                                            });

                                            self._args.building.sections.filter(function(section){
                                                return section.id == self._args.item.id;
                                            }).pop().flats = self._args.item.flats;
                                            self._args.building.sections.filter(function(section){
                                                return section.id == self._args.item.id;
                                            }).pop().floors = self._args.item.floors;

                                            self._args.chess._args.building.sections = self._args.building.sections;

                                            self._args.chess._updateSections();
                                            self._args.chess._updateStickySections();
                                            self._args.chess._updateCurrentSection();
                                            self._args.chess._updateFlatTitles();
                                            self._args.chess._unselectAll();
                                            self._args.progress.update({
                                                object : self._args.object
                                            });

                                            self._args.chess._args.buildingSelf._state.item.sections = self._args.building.sections;
                                            self._args.chess._args.buildingSelf._bindUI();

                                            response.flats.forEach(function (response_flat) {
                                                $('.chess-flat[data-id=' + response_flat.id + ']').addClass('new');
                                                setTimeout(function(){
                                                    $('.chess-flat[data-id=' + response_flat.id + ']').removeClass('new');
                                                }, 3000);
                                            });
                                        }
                                    });
                                }
                            });
                        });
                    }
                });
                return;
            }

            let selected_flats = self._args.chess._getNonExistentSelectedFlats();

            if (!selected_flats.length) {
                new Modal({
                    title: 'Информация',
                    content: Utils.renderProfileTemplate('info', {
                        message : 'Пожалуйста, выделите хотя бы одну пустую ячейку. Чтобы выделить пустую ячейку, достаточно нажать на неё один раз.',
                        buttons : {
                            one : {
                                class : 'confirm button--edit',
                                title : 'Закрыть'
                            },
                            two : null
                        }
                    })
                });
                return;
            }

            self._args.item = self._args.chess._getSectionById(selected_flats[0].id);

            loader.increase();
            return Request.send({
                path: '/api/objects/' + self._args.object.id + '/buildings/' + self._args.building.id,
                data: {
                    info: 'for_flat'
                },
                done: function(response) {
                    loader.decrease();
                    Utils.scrollToTop();

                    let sections         = self._args.building.sections.filter(function(section){
                        return section.id == self._args.item.id;
                    });
                    if (!sections.length) return;
                    self._args.item      = sections[0];
                    self._args.building  = response.building;
                    self._args.object    = self._args.building.object;

                    new Flat({
                        progress       : self._args.progress,
                        building       : self._args.building,
                        section        : self._args.item,
                        group          : false,
                        items          : selected_flats,
                        item           : {},
                        done           : function (response) {
                            response.flats.forEach(function (response_flat) {
                                self._args.item.flats.push(response_flat);
                            });

                            self._args.building.sections.filter(function(section){
                                return section.id == self._args.item.id;
                            }).pop().flats = self._args.item.flats;
                            self._args.chess._args.building.sections = self._args.building.sections;

                            self._args.chess._updateSections();
                            self._args.chess._updateStickySections();
                            self._args.chess._updateCurrentSection();
                            self._args.chess._updateFlatTitles();
                            self._args.chess._unselectAll();
                            self._args.progress.update({
                                object : self._args.object
                            });

                            self._args.chess._args.buildingSelf._state.item.sections = self._args.building.sections;
                            self._args.chess._args.buildingSelf._bindUI();

                            response.flats.forEach(function (response_flat) {
                                $('.chess-flat[data-id=' + response_flat.id + ']').addClass('new');
                                setTimeout(function(){
                                    $('.chess-flat[data-id=' + response_flat.id + ']').removeClass('new');
                                }, 3000);
                            });
                        }
                    });
                }
            });
        });

        self._elems.$_.find('.js-profile-edit-flats').unbind('click').on('click', function (e) {
            e.preventDefault();

            if ($(this).hasClass('disabled')) return;

            $('.chess__control__extra').removeClass('active');

            if (self._args.chess.getExistentSelectedFlats().length == 0) {
                new Modal({
                    title: 'Информация',
                    content: Utils.renderProfileTemplate('info', {
                        message : 'Пожалуйста, выделите хотя бы одну заполненную ячейку. Чтобы выделить заполненную ячейку, достаточно нажать на неё один раз.',
                        buttons : {
                            one : {
                                class : 'confirm button--edit',
                                title : 'Закрыть'
                            },
                            two : null
                        }
                    })
                });
                return;
            }

            let selected_flats = self._args.chess.getExistentSelectedFlats();
            let item = self._args.chess._getSectionById(selected_flats[0].id);

            loader.increase();
            return Request.send({
                path: '/api/objects/' + self._args.object.id + '/buildings/' + self._args.building.id,
                data: {
                    info: 'for_flat'
                },
                done: function(response) {
                    loader.decrease();
                    Utils.scrollToTop();

                    self._args.building  = response.building;
                    self._args.object    = self._args.building.object;

                    let sections         = self._args.building.sections.filter(function(section){
                        return section.id == item.id;
                    });
                    if (!sections.length) return;
                    self._args.item      = sections[0];

                    for(var i = 0; i < selected_flats[0].flats.length; i++){
                        selected_flats[0].flats[i] = self._args.item.flats.filter(function(flat){
                            return flat.id == selected_flats[0].flats[i].id;
                        }).pop();
                    }
                    let common_flat = {};

                    selected_flats[0].flats.forEach(function (selected_flat) {
                        let flat = self._args.chess._getFlatBySectionAndId(self._args.item, selected_flat.id);

                        Object.keys(flat).forEach(function (property_name) {
                            if (['id', 'floor_id', 'column_index'].indexOf(property_name) > -1) return;

                            if (property_name == 'images') {
                                if (common_flat.images === null) return;

                                if (common_flat.images === undefined && flat.images) {
                                    common_flat.images = flat.images;
                                    return;
                                }

                                var common_flat_image_string = common_flat.images.map(function (image) {
                                    return image.id;
                                }).join('-');

                                var flat_image_string = flat.images.map(function (image) {
                                    return image.id;
                                }).join('-');

                                if (common_flat_image_string !== flat_image_string) {
                                    common_flat.images = null;
                                    return;
                                }
                                return;
                            }

                            if (common_flat[property_name] === undefined) {
                                common_flat[property_name] = flat[property_name];
                                return;
                            }

                            if(property_name == 'commerce_type') {
                                if (JSON.stringify(common_flat[property_name]) !== JSON.stringify(flat[property_name])) {
                                    common_flat[property_name] = null;
                                    return;
                                }
                                return;
                            }

                            if(property_name == 'price') {
                                if (common_flat[property_name] !== flat[property_name]) {
                                    common_flat[property_name] = null;
                                    return;
                                }
                                return;
                            }
                            if(property_name == 'monthly_price') {
                                if (common_flat[property_name] !== flat[property_name]) {
                                    common_flat[property_name] = null;
                                    return;
                                }
                                return;
                            }

                            if(property_name == 'price_per_square_meter' || property_name == 'price_type' || property_name == 'monthly_price_per_square_meter' || property_name == 'monthly_price_type')
                                return;

                            if (property_name == 'each_room_area' && common_flat[property_name] != null) {
                                for (let i in flat[property_name]) {
                                    if (common_flat[property_name] == null) continue;
                                    if (flat[property_name][i] != common_flat[property_name][i]) {
                                        common_flat[property_name] = null;
                                    }
                                }
                                return;
                                // common_flat[property_name]
                            }

                            if (common_flat[property_name] !== flat[property_name]) {
                                common_flat[property_name] = null;
                                return;
                            }
                        });
                    });

                    new Flat({
                        progress       : self._args.progress,
                        section        : self._args.item,
                        building       : self._args.building,
                        group          : false,
                        items          : selected_flats,
                        item           : common_flat,
                        done           : function (response) {
                            response.flats.forEach(function (response_flat) {
                                let flat = self._args.chess._getFlatBySectionAndId(self._args.item, response_flat.id);
                                self._args.item.flats[self._args.item.flats.indexOf(flat)] = response_flat;
                            });

                            self._args.chess._args.building.sections.filter(function(section){
                                return section.id == self._args.item.id;
                            }).pop().flats = self._args.item.flats;

                            self._args.chess._updateSections();
                            self._args.chess._updateStickySections();
                            self._args.chess._updateCurrentSection();
                            self._args.chess._updateFlatTitles();
                            self._args.chess._unselectAll();

                            self._args.progress.update({
                                object : self._args.object
                            });

                            self._args.chess._args.buildingSelf._state.item.sections = self._args.building.sections;
                            self._args.chess._args.buildingSelf._bindUI();

                            response.flats.forEach(function (response_flat) {
                                $('.chess-flat[data-id=' + response_flat.id + ']').addClass('new');
                                setTimeout(function(){
                                    $('.chess-flat[data-id=' + response_flat.id + ']').removeClass('new');
                                }, 3000);
                            });
                        }
                    });
                }
            });
        });

        self._elems.$_.find('.js-profile-edit-main-flat').unbind('click').on('click', function (e) {
            e.preventDefault();

            if (!self._args.chess.getExistentSelectedFlats().length) return;

            let selected_flats = self._args.chess.getExistentSelectedFlats();
            let item = self._args.chess._getSectionById(selected_flats[0].id);
            let section_index = self._args.building.sections.indexOf(item);
            let $section = self._args.chess._elems.$slider.children().eq(section_index).children();

            new Modal({
                title: 'Следующий шаг',
                content: Utils.renderProfileTemplate('info', {
                    message : 'Пожалуйста, выберите главное помещение группы.',
                    buttons : {
                        one : {
                            class : 'confirm button--edit',
                            title : 'Продолжить'
                        },
                        two : {
                            class : 'button--cancel',
                            title : 'Отменить'
                        }
                    }
                }),
                confirm : function(args) {
                    let $modal = args.modal;
                    $modal.trigger('close');

                    self._args.chess.enableMainFlatSelectionMode(item, section_index, $section, selected_flats[0].flats, function (main_flat) {
                        return Request.send({
                            path: '/api/objects/' + self._args.object.id + '/buildings/' + self._args.building.id + '/' + self._const.entities + '/' + item.id + '/flats/' + main_flat.id + '/make_main',
                            method: 'POST',

                            done: function (response) {
                                if (response.error) {
                                    self.profile.callback.error(response.error, form);
                                    return;
                                }

                                item.flats.filter(function (flat) {
                                    return flat.group && flat.group.id == main_flat.group.id;
                                }).forEach(function (flat) {
                                    return flat.group.main_flat_id = main_flat.id;
                                });

                                self._args.chess._updateSections();
                                self._args.chess._updateStickySections();
                                self._args.chess._updateCurrentSection();
                                self._args.chess._updateFlatTitles();
                                self._args.chess._unselectAll();

                                self._args.chess._args.buildingSelf._state.item.sections = self._args.building.sections;
                                self._args.chess._args.buildingSelf._bindUI();
                            }
                        });
                    });
                }
            });
        });

        self._elems.$_.find('.js-profile-edit-floors').unbind('click').on('click', function (e) {
            e.preventDefault();

            if ($(this).hasClass('disabled')) return;

            $('.chess__control__extra').removeClass('active');

            new Floor({
                mode     : Vars.view.building,
                chess    : self._args.chess,
                building : self._args.building,
                progress : self._args.progress
            });
        });

        self._elems.$_.find('.js-profile-control-flats-delete').unbind('click').on('click', function (e) {
            e.preventDefault();

            if ($(this).hasClass('disabled')) return;

            $('.chess__control__extra').removeClass('active');

            if (self._args.chess._getSelectedFlats().length == 0) {
                new Modal({
                    title: 'Информация',
                    content: Utils.renderProfileTemplate('info', {
                        message : 'Пожалуйста, выделите хотя бы одну заполненную ячейку. Чтобы выделить заполненную ячейку, достаточно нажать на неё один раз.',
                        buttons : {
                            one : {
                                class : 'confirm button--edit',
                                title : 'Закрыть'
                            },
                            two : null
                        }
                    })
                });

                return;
            }

            var selected_flats = self._args.chess.getExistentSelectedFlats();
            var item = self._args.chess._getSectionById(selected_flats[0].id);

            new Modal({
                title: 'Удаление помещений',
                content: Utils.renderProfileTemplate('info', {
                    message : 'Вы действительно хотите удалить выделенные помещения?',
                    buttons : {
                        one : {
                            class : 'confirm button--remove',
                            title : 'Да, удалить'
                        },
                        two : {
                            class : 'button--cancel',
                            title : 'Нет, отменить'
                        }
                    }
                }),
                confirm : function(args) {
                    loader.increase();

                    let $modal = args.modal;

                    Request.send({
                        path: '/api/objects/' + self._args.object.id + '/buildings/' + self._args.building.id + '/' + self._const.entities + '/' + item.id + '/flats/remove',
                        method: 'POST',
                        data: $.param({
                            flats: selected_flats[0].flats.map(function (flat) {
                                return {id: flat.id};
                            }),
                        }),

                        done: function (response) {
                            loader.decrease();

                            $modal.trigger('close');

                            if (response.error) {
                                console.error(response.error);
                                return;
                            }

                            selected_flats[0].flats.forEach(function (request_flat) {
                                var flat = self._args.chess._getFlatBySectionAndId(item, request_flat.id);
                                item.flats.splice(item.flats.indexOf(flat), 1);
                            });

                            response.floors.forEach(function (response_floor) {
                                var floor = null;
                                var floor_index = -1;

                                item.floors.some(function (current_floor, current_floor_index) {
                                    if (current_floor.id != response_floor.id) {
                                        return false;
                                    }

                                    floor = current_floor;
                                    floor_index = current_floor_index;
                                    return true;
                                });

                                if (!floor)
                                    return;

                                item.floors[floor_index] = response_floor;
                            });

                            self._args.chess._updateSections();
                            self._args.chess._updateStickySections();
                            self._args.chess._updateCurrentSection();
                            self._args.chess._updateFlatTitles();
                            self._args.chess._unselectAll();

                            self._args.progress.update({
                                object : self._args.object
                            });

                            self._args.chess._args.buildingSelf._state.item.sections = self._args.building.sections;
                            self._args.chess._args.buildingSelf._bindUI();
                        }
                    });
                }
            });
        });
    };

    _init = () => {
        let self = this;

        if (self._args.mode === Vars.view.building) {
            self._building();
        } else if (self._args.mode === Vars.view.control) {
            self._control();
        }
    };
}

export default Section;